import React from "react";
import { useNavigate } from "react-router";

import { getDashboardsPagePath } from "utils/router.utils";

import AgTable from "components/AgTable";

import { getSystemsTableConfig } from "./SystemsTable.config";

const SystemsTable = ({ systems, filterValue, setFilterSystems, showTableFilterIcon }) => {
  const navigate = useNavigate();

  const handleClickOnSystemRow = event => {
    const { sysId } = event.data;
    const path = getDashboardsPagePath(sysId);
    navigate(path);
  };

  const columdefs = getSystemsTableConfig(showTableFilterIcon);

  return (
    <>
      <AgTable
        rowData={systems}
        onRowClicked={handleClickOnSystemRow}
        quickFilterText={filterValue}
        columnDefs={columdefs}
        customHeight="300px"
        setBadgeCount={setFilterSystems}
        suppressScrollOnNewData
      />
    </>
  );
};

export default SystemsTable;
